var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg054Clip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.694,50.624c-18.473-18.679-40.704-28.526-64.357-28.526c-0.368,0-0.737,0.002-1.106,0.007 c-22.542,0.292-44.66,9.872-62.278,26.973l-0.166,0.161L127.082,281.761c-22.883,23.123-22.889,56.695-0.014,79.825 c11.093,11.216,25.244,17.392,39.848,17.392h0.007c14.781-0.002,29.025-6.178,40.177-17.459l158.073-161.49 c7.724-7.891,7.589-20.549-0.303-28.274c-7.89-7.724-20.55-7.589-28.274,0.302l-158.004,161.42 c-3.515,3.555-7.66,5.513-11.676,5.514c-3.951,0-7.793-1.858-11.419-5.523c-10.525-10.642-3.502-20.035,0.049-23.623 L383.958,77.62c21.828-21.058,49.796-20.625,71.305,1.123c25.497,25.78,18.557,55.864,0.37,74.244 c-7.767,7.848-7.7,20.507,0.147,28.275c7.851,7.768,20.509,7.699,28.275-0.148c17.548-17.732,27.467-40.276,27.928-63.475 C512.466,93.357,502.419,69.558,483.694,50.624z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.9,217.665c-7.931-7.68-20.59-7.477-28.271,0.456L195.287,421.935c-17.865,18.04-40.468,27.976-63.656,27.979h-0.012 c-23.18,0-45.172-9.846-63.594-28.472c-43.121-43.599-31.082-94.804-0.012-126.229l197.04-196.996 c7.809-7.807,7.81-20.466,0.003-28.275c-7.806-7.809-20.465-7.81-28.275-0.003L39.703,266.973l-0.075,0.076 c-24.714,24.974-38.772,56.464-39.589,88.671c-0.871,34.344,12.808,66.794,39.556,93.84 c25.729,26.015,58.409,40.341,92.024,40.341h0.018c33.984-0.005,66.713-14.184,92.157-39.925l197.562-204.04 C429.037,238.003,428.833,225.345,420.9,217.665z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg054Clip);
export default __webpack_public_path__ + "static/media/054-clip.683f9158c5cd0ea6b30926f5448dd40d.svg";
export { ForwardRef as ReactComponent };